/**
 * Markers ErrorStub (`@bingads-webui/instrumentation-stubs`) uses when it flattens a global error
 * into a single string:
 *
 *   `${message}\tScript: ${url} Line: ${line}[ Column: ${col}][ StackTrace: ${frames}]`
 *   + `\tCurrentURL: ${href}\tPreviousURL: ${referrer}`
 *
 * Both the formatter that parses this into columns and the filter that caps repeated reports have
 * to agree on the shape, so the markers live here rather than being duplicated in each.
 */

export const ON_ERROR_API = 'onerror';

export const ON_REJECTION_API = 'onunhandledrejection';

export const GLOBAL_ERROR_APIS = [ON_ERROR_API, ON_REJECTION_API];

export const SCRIPT_MARKER = '\tScript: ';

export const CURRENT_URL_MARKER = '\tCurrentURL: ';

export const LINE_MARKER = ' Line: ';

export const COLUMN_MARKER = ' Column: ';

export const STACK_MARKER = ' StackTrace: ';

export const REJECTION_STACK_MARKER = '; StackTrace: ';

/**
 * Appended to a sampled report to say how many occurrences it stands for, so a query can recover
 * the true rate after the storm filter stops sending every row.
 */
export const REPEAT_COUNT_MARKER = '\tRepeatCount: ';
